/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plane_Patient_Blackbird_LaughInputs */

const fr_plane_patient_blackbird_laugh = /** @type {(inputs: Plane_Patient_Blackbird_LaughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre coach n'a pas encore programmé de semaines d'entraînement.`)
};

/**

* @param {Plane_Patient_Blackbird_LaughInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plane_patient_blackbird_laugh = /** @type {((inputs?: Plane_Patient_Blackbird_LaughInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plane_Patient_Blackbird_LaughInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plane_patient_blackbird_laugh(inputs)
});